export default "__VITE_ASSET__CKj_Tcst__"